<template>
  <b-container>
    <success-fade-alert ref="success" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <h4>
      {{ $t("forgotPassword.redefineByPersonalDocument") }}
    </h4>

    <b-form-group
      :label="$t('redefinePassword.cnpj')"
      label-for="input-companyDocument"
    >
      <b-form-input
        type="text"
        id="input-companyDocument"
        :placeholder="$t('redefinePassword.reportCnpj')"
        v-model="changePassowrd.companyDocument"
        v-mask="'99.999.999/9999-99'"
      />
      <span class="text-danger" v-if="modelstate['CompanyDocument']">
        {{ modelstate["CompanyDocument"][0] }}
      </span>
    </b-form-group>
    <b-form-group
      :label="$t('redefinePassword.cpf')"
      label-for="input-userDocument"
    >
      <b-form-input
        type="text"
        id="input-personalDocument"
        :placeholder="$t('redefinePassword.reportCpf')"
        v-model="changePassowrd.userDocument"
        v-mask="'999.999.999-99'"
      />
      <span class="text-danger" v-if="modelstate['UserDocument']">
        {{ modelstate["UserDocument"][0] }}
      </span>
    </b-form-group>
    <b-form-group
      :label="$t('redefinePassword.accessName')"
      label-for="input-accessName"
    >
      <b-form-input
        type="text"
        id="input-accessName"
        :placeholder="$t('redefinePassword.reportAccessName')"
        label-for="input-accessName"
        v-model="changePassowrd.accessName"
      />
      <span class="text-danger" v-if="modelstate['AccessName']">
        {{ modelstate["AccessName"][0] }}
      </span>
    </b-form-group>

    <rms-password
      :label="$t('redefinePassword.newPassword')"
      :placeholder="$t('redefinePassword.reportNewPassword')"
      :value.sync="changePassowrd.newPassword"
      :modelstate="modelstate"
    ></rms-password>
    <div>
      <span class="text-danger" v-if="modelstate['NewPassword']">
        {{ modelstate["NewPassword"][0] }}
      </span>
    </div>

    <b-button @click="send()">
      {{ $t("redefinePassword.redefinePassword") }}
    </b-button>
  </b-container>
</template>
<script>
import AwesomeMask from "awesome-mask";
export default {
  name: "ResetPasswordComponent",
  directives: {
    mask: AwesomeMask,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    RmsPassword: () => import("@/components/RmsInputs/RmsPassword.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Senha alterada com sucesso",
      },
      changePassowrd: {
        companyDocument: "",
        userDocument: "",
        accessName: "",
        newPassword: "",
      },
      modelstate: {},
    };
  },
  methods: {
    async send() {
      try {
        let companyDocument = this.changePassowrd.companyDocument;
        let accessName = this.changePassowrd.accessName;
        let userDocument = this.changePassowrd.userDocument;
        let newPassword = this.changePassowrd.newPassword;
        await this.$store
          .dispatch("redefinePassword", {
            companyDocument: companyDocument,
            userDocument: userDocument,
            accessName: accessName,
            newPassword: newPassword,
          })
          .then(() => {
            this.$refs.success.show();
            this.changePassowrd = {
              companyDocument: "",
              userDocument: "",
              accessName: "",
              newPassword: "",
            };
            this.modelstate = {};
          })
          // .catch((error) => {
          //   console.log(error);
          //   console.log(error.response);
          //   this.modelstate = error.response.data.errors;
          //   if(error.response.status == 400)
          //   {
          //     this.alert.error = `${error.response.status} - ${error.reponse.data}`;
          //     this.$refs.danger.show();
          //   }
          //   else if (error.response) {
          //     this.alert.error = `${error.response.data.status} - ${error.response.data.title}`;
          //   } else {
          //     this.alert.error = error.toString();
          //   }
          //   this.$refs.danger.show();
          // });
      } catch (error) {
        console.log(error)
        console.log(error.response);
        if (error.response) {
          if (error.response.status == 500) {
            this.alert.error = error.response.data;
            this.$refs.danger.show();
          } else if(error.response.status == 400){
            this.alert.error = `${error.response.status} - ${error.response.data}`;
            this.$refs.danger.show();
          }          
          else {
            this.modelstate = error.response.data.errors;
            this.alert.error = `${error.response.status} - ${error.response.statusText}`;
            this.$refs.danger.show();
          }
        }
        // console.log(error);
        // this.alert.error = `Erro inexperado: ${error}`;
        this.$refs.danger.show();
      }
    },
  },
};
</script>
<style scoped>
h4 {
  color: #525f7f;
}

.right {
  text-align: right;
  width: 100%;
}
.forgetPassword {
  margin-top: -15px !important;
  margin-left: -20px;
  text-align: left !important;
}
</style>
